import { RootState } from "@/redux/store";

export const accessControlSelector = (state: RootState) => state.business.accessControl;
export const billingSettingsSelector = (state: RootState) => state.business.billingSettings;
export const businessDetailsSelector = (state: RootState) => state.business.businessDetails;
export const dispatchSettingsSelector = (state: RootState) => state.business.dispatchSettings;
export const displayOptionsSelector = (state: RootState) => state.business.displayOptions;
export const emailNotificationsSelector = (state: RootState) => state.business.emailNotifications;
export const smsVoiceNotificationsSelector = (state: RootState) => state.business.smsVoiceNotifications;
export const websiteDetailsSelector = (state: RootState) => state.business.websiteDetails;
export const waitingTimesSelector = (state: RootState) => state.business.waitingTimes;
